import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import MapDataSource from "../../Map/Enums/MapDataSource";
import MapLayer from "../../Map/Enums/MapLayer";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import MapLayerManager from "../../Map/MapLayerManager";
import { Layout, Paint } from "../../Map/MapLayerStyles";
import MapStore from "../../Map/Store";

const RoutePlotWindowStore = {
	meta: {
		loadState: writable(LoadState.INIT),
		mapInitted: writable(false)
	},
	actions: {
		initMap: () => {
			if (get(RoutePlotWindowStore.meta.mapInitted)) {
				return;
			}
			const map = get(MapStore.mapbox.instance);

			map.addSource(MapDataSource.MEASURE_POINTS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.MEASURE_POINT_LINES, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.MEASURE_LABELS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addSource(MapDataSource.ROUTEPLOT_POINTS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.ROUTEPLOT_POINT_LINES, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.ROUTEPLOT_LABELS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addLayer(
				{
					id: MapLayer.MEASURE_POINT_LINES,
					type: "line",
					source: MapDataSource.MEASURE_POINT_LINES,
					layout: Layout.measure,
					paint: Paint.measure.lines
				}
			);
			map.addLayer(
				{
					id: MapLayer.MEASURE_POINTS,
					type: "circle",
					source: MapDataSource.MEASURE_POINTS,
					paint: Paint.measure.points
				}
			);
			map.addLayer(
				{
					id: MapLayer.MEASURE_LABELS,
					type: "symbol",
					source: MapDataSource.MEASURE_LABELS,
					layout: Layout.measureText,
					paint: Paint.measure.text
				}
			);

			map.addLayer(
				{
					id: MapLayer.ROUTEPLOT_POINT_LINES,
					type: "line",
					source: MapDataSource.ROUTEPLOT_POINT_LINES,
					layout: Layout.measure,
					paint: Paint.measure.lines
				}
			);
			map.addLayer(
				{
					id: MapLayer.ROUTEPLOT_POINTS,
					type: "circle",
					source: MapDataSource.ROUTEPLOT_POINTS,
					paint: Paint.measure.points
				}
			);
			map.addLayer(
				{
					id: MapLayer.ROUTEPLOT_LABELS,
					type: "symbol",
					source: MapDataSource.ROUTEPLOT_LABELS,
					layout: Layout.measureText,
					paint: Paint.measure.text
				}
			);

			MapLayerManager.addLayerGroup(MapLayerGroup.ROUTE_PLOT, [
				MapLayer.MEASURE_POINT_LINES,
				MapLayer.MEASURE_POINTS,
				MapLayer.MEASURE_LABELS,
				MapLayer.ROUTEPLOT_POINT_LINES,
				MapLayer.ROUTEPLOT_POINTS,
				MapLayer.ROUTEPLOT_LABELS
			], [
				MapDataSource.MEASURE_POINTS,
				MapDataSource.MEASURE_POINT_LINES,
				MapDataSource.MEASURE_LABELS,
				MapDataSource.ROUTEPLOT_POINTS,
				MapDataSource.ROUTEPLOT_POINT_LINES,
				MapDataSource.ROUTEPLOT_LABELS
			]);
			RoutePlotWindowStore.meta.mapInitted.set(true);
		},
		deinitMap: () => {
			if (!get(RoutePlotWindowStore.meta.mapInitted)) {
				return;
			}
			MapLayerManager.removeLayerGroup(MapLayerGroup.ROUTE_PLOT);
			RoutePlotWindowStore.meta.mapInitted.set(false);
		}
	}
};
export default RoutePlotWindowStore;
